import { render, staticRenderFns } from "./ElPostBreadcrumbs.vue?vue&type=template&id=07ac0dc2"
import script from "./ElPostBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./ElPostBreadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./ElPostBreadcrumbs.vue?vue&type=style&index=0&id=07ac0dc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports